// src/head/vr.js
(function(){
  try {
    window.__STOCKSTORM_HEAD = (window.__STOCKSTORM_HEAD || {});
    window.__STOCKSTORM_HEAD.vr = true;
    if (typeof console !== 'undefined' && console.log) {
      console.log('StockStorm: vr head bundle loaded');
    }

    // Align with desktop model-viewer loading logic
    var params = new URLSearchParams(location.search);
    var mv = params.get('mv');
    var shouldLoad = (mv === null || mv === '' || mv === '1' || String(mv).toLowerCase() === 'true');

    var isMobile = /(iPhone|iPad|iPod|Android|Mobi|Tablet)/i.test(navigator.userAgent);
    
    let storedQualityLevel = null;
    try {
      const rawSettings = localStorage.getItem('mainSettings');
      if (rawSettings) storedQualityLevel = JSON.parse(rawSettings)?.value?.quality;
    } catch (e) {}

    
    // Store settings globally for a-frame components to pick up
    const defaultBloomStatus = isMobile ? false : (params.get('bloom') !== '0' && params.get('bloom') !== 'false'); 
    const defaultPixelRatio = parseFloat(params.get('pr')) || (isMobile ? 1.5 : 2);
    const defaultAntialias = params.get('aa') !== '0' && params.get('aa') !== 'false';
    const defaultHighRefreshRate = params.get('hrr') !== '0' && params.get('hrr') !== 'false';
    const defaultFoveationLevel = params.get('fl') !== null ? parseInt(params.get('fl')) : (isMobile ? 1 : 0);
    
    
    window.__STOCKSTORM_CONFIG = {
      mv: shouldLoad,
      bloom: storedQualityLevel ? (storedQualityLevel === 'quality') : defaultBloomStatus, 
      pixelRatio: storedQualityLevel ? (storedQualityLevel === 'quality' ? 2 : 1.5) : defaultPixelRatio,
      antialias: storedQualityLevel ? (storedQualityLevel === 'quality') : defaultAntialias,
      highRefreshRate: storedQualityLevel ? (storedQualityLevel === 'quality') : defaultHighRefreshRate,
      foveationLevel: storedQualityLevel ? (storedQualityLevel === 'quality' ? 0 : 1) : defaultFoveationLevel,
    };
    setLevelQuality();

    if (shouldLoad) {
      var s = document.createElement('script');
      s.type = 'module';
      s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
      document.head.appendChild(s);
    } else {
      console.info('[MV] Skipping model-viewer load via ?mv=0');
    }
  } catch (_) { /* no-op */ }
})();

function setLevelQuality() {
  const scene = document.getElementById('main-scene');
  if (!scene) return
  const config = window.__STOCKSTORM_CONFIG || {};
  console.log('Applying configuration: ', config)

  // Set renderer tweaks
  const pr = config.pixelRatio || 2;
  scene.setAttribute('renderer-tweaks', 'pixelRatio: ' + pr);
  // scene.setAttribute('renderer-tweaks', 'pixelRatio: 2');

  // Set renderer
  const aa = (config.antialias !== undefined) ? config.antialias : true;
  const hrr = (config.highRefreshRate !== undefined) ? config.highRefreshRate : true;
  const fl = (config.foveationLevel !== undefined) ? config.foveationLevel : 0;
  scene.setAttribute('renderer', 'antialias: ' + aa + '; highRefreshRate: ' + hrr + '; foveationLevel: ' + fl + ';');

  // Set bloom
  const bloomEnabled = (config.bloom !== undefined) ? config.bloom : true;
  scene.setAttribute('bloom', 'threshold: 1; strength: 0.2; radius: 0.1;');
}

if (typeof AFRAME !== 'undefined') {
  AFRAME.registerComponent('renderer-tweaks', {
    schema: { pixelRatio: { type: 'number', default: (window.__STOCKSTORM_CONFIG && window.__STOCKSTORM_CONFIG.pixelRatio) || 1.5 } },
    init: function () {
      const renderer = this.el.sceneEl.renderer;
      if (renderer) {
        renderer.setPixelRatio(this.data.pixelRatio);
        console.log('Pixel Ratio Set To:', renderer.getPixelRatio());
      }
    }
  });
}

import '../../vr_scripts/lightweight-charts.js';
import '../../js/aframe-environment-component.js';
import '../../js/aframe-html.js';
// import '../../post-processing/bloom.js';
